import * as React from 'react';
import { Outlet, useNavigate } from 'react-router';
import { resetSession, userSession } from 'state/session';

import DealerEntry, { IDealerEntryProps } from './DealerEntry';
import { normalizePath } from 'utils/url';

export type IDealerEntryContainerProps = Omit<IDealerEntryProps, 'endSessionCallback'>;

const DealerEntryContainer: React.FC<IDealerEntryContainerProps> = (props) => {
  const navigate = useNavigate();
  const session = userSession().useState();

  React.useEffect(() => {
    if (!session.brand || !session.market) {
      // this is a rare case where the session is not initialized timely
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const userAlreadyRated = session.ratingCompleted;

    if (userSession().presentationEndedWithoutRating) {
      if (userSession().sessionEnded) {
        // presentation started, shared, ended, but not yet rated
        navigate(`/${session.brand}/${session.market}/${session.id}/goodbye?${searchParams.toString()}`);
      } else {
        // Presentation started but not yet ended
        // Initialize session if not already done
        navigate(`/${session.brand}/${session.market}/${session.id}?${searchParams.toString()}`);
      }
    } else if (!session.id || userAlreadyRated || userSession().sessionAbandoned) {
      // If no session ID, redirect to the home page

      const currentPath = `/${session.brand}/${session.market}/`;

      if (normalizePath(window.location.pathname) !== normalizePath(currentPath)) {
        resetSession();
        // prevent race condition due to value changes on session reset
        const targetPath = `${currentPath}?${searchParams.toString()}`;
        navigate(targetPath);
      }
    }
  }, [
    session.id,
    session.ratingCompleted,
    session.endedAt,
    session.streamActive,
    session.brand,
    session.market,
    session.isShared,
    navigate,
  ]);

  return (
    <DealerEntry {...props}>
      <Outlet />
    </DealerEntry>
  );
};

export default DealerEntryContainer;
